import { StateCreator } from "zustand"
import { Conversation } from "@src/types"
import type * as StoreTypes from "@src/types/store"

const initState = {
  conversations: [],
}

export const createConversationSlice: StateCreator<
  StoreTypes.StoreState,
  [],
  [],
  StoreTypes.ConversationSlice
> = (set) => ({
  ...initState,
  addConversation: (conversation: Conversation) => {
    set((state) => ({
      conversations: [...state.conversations, conversation],
    }))
  },
  updateConversation: (id: string, updates: Partial<Conversation>) => {
    set((state) => ({
      conversations: state.conversations.map((conversation) =>
        conversation.id === id ? { ...conversation, ...updates } : conversation,
      ),
    }))
  },
  deleteConversation: (id: string) => {
    set((state) => ({
      conversations: state.conversations.filter((conversation) => conversation.id !== id),
    }))
  },
  resetConversations: () => {
    set({ ...initState })
  },
})
